import { render, staticRenderFns } from "./FlowImport2.vue?vue&type=template&id=76f3977e"
import script from "./FlowImport2.vue?vue&type=script&lang=js"
export * from "./FlowImport2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports